var app = angular.module("leonardo");

var WorkflowInstanceEditDialog = function($scope, FormErrorsService) {
  $scope.workflow = $scope.ngDialogData.workflow;

  $scope.data = {
    name: $scope.workflow.name,
    date_of_turn: $scope.workflow.date_of_turn
  };
  $scope.start = $scope.workflow.date_of_turn;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.workflow.patch($scope.data).then(function() {
      $scope.confirm();
    });
  };
};

app.controller('WorkflowInstanceEditDialog', ['$scope', 'FormErrorsService', WorkflowInstanceEditDialog]);
